<app-page-header></app-page-header>
<app-breadcromb pageName="Register"></app-breadcromb>
<!-- Login Area Start -->
<section class="jobguru-login-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div *ngIf="!registerSuccess" class="login-box">
          <div class="login-title">
            <h3>Sign up</h3>
          </div>
          <form [formGroup]="registerForm" (ngSubmit)="registerUser()">
            <div class="single-login-field">
              <input type="text" formControlName="username" placeholder="Username">
              <div class="text-danger" *ngIf="d.username.touched && d.username.invalid">
                <span *ngIf="d.username.errors.required">
                  Username is a required field
                </span>
              </div>
              <div class="text-danger" *ngIf="d.username.touched && d.username.invalid">
                <span *ngIf="d.username.errors.minlength">
                  Username should be at least 4 characters
                </span></div>
            </div>
            <div class="single-login-field">
              <input type="email" formControlName="email" placeholder="Email Address">
              <div class="text-danger" *ngIf="d.email.touched && d.email.invalid">
                <span *ngIf="d.email.errors.required">Email is a required field</span>
              </div>
              <div class="text-danger" *ngIf="d.email.touched && d.email.invalid">
                <span *ngIf="d.email.errors.invalidEmail">Email field should be a valid email</span>
              </div>
            </div>
            <div class="single-login-field">
              <input type="password" formControlName="password" placeholder="Choose Password">
              <div class="text-danger" *ngIf="d.password.touched && d.password.invalid">
                <span *ngIf="d.password.errors.required">
                  Password is required
                </span>
              </div>
              <div class="text-danger" *ngIf="d.password.touched && d.password.invalid">
                <span *ngIf="d.password.errors.minlength">
                  Password should be at least 8 characters
                </span>
              </div>
            </div>
            <div class="single-login-field">
              <input type="password" formControlName="password_confirmation" placeholder="Confirm Password">
              <div class="text-danger" *ngIf="d.password_confirmation.touched && d.password_confirmation.invalid">
                <span *ngIf="d.password_confirmation.errors.required">Password confirmation is a required field</span>
              </div>
              <div class="text-danger" *ngIf="d.password_confirmation.touched && d.password_confirmation.invalid">
                <span *ngIf="d.password_confirmation.errors.passwordMisMatch">Password do not match</span>
              </div>
            </div>
            <div class="remember-row single-login-field clearfix">
              <p class="checkbox remember">
                <input class="checkbox-spin" type="checkbox" id="Freelance">
                <label for="Freelance"><span></span>accept terms & condition</label>
              </p>
            </div>
            <div class="single-login-field">
              <button [disabled]="registerForm.invalid" type="submit" class="btn btn-primary btn-xs">Register</button>
            </div>
          </form>
          <div class="dont_have">
            <a href="#" routerLink="/login">Already have an account?</a>
          </div>
        </div>
        <div *ngIf="registerSuccess" class="bg-success" style="border-radius: 20px;">
          <p style="padding: 4px; width: auto; color: white; text-align: center">{{regResponse.data}} <a href="#"
                                                                                                         routerLink="/login">Login</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Login Area End -->
